import { Injectable } from '@angular/core';

import { Point } from '../models';
import { AppState } from '../app-state';

import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { PointDoc, pointPullQueryBuilder, pointSchema } from '../schema/point-schema';
import { RestClient } from './rest-client';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class PointRestClient extends RestClient<Point> {

    constructor(http: HttpClient, appState: AppState) {
      super(http, 'point', appState)
    }
};

@Injectable({ providedIn: "root" })
export class PointService extends TestbedRxdbGraphQlCollectionService<Point,PointDoc>{

    constructor( appState : AppState, authService: AuthenticationService, rxdbState: TestbedRxdbState,
        public restClient: PointRestClient ) {
        super('point', pointSchema, appState, rxdbState, authService)
        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.point.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: pointPullQueryBuilder(),
            graphQLSubscription:
            `subscription{
                pointUpdated{
                    points{
                        _id
                    }
                }
            }`
        }
    }

    async isStage(buildingId: string, stage: string): Promise<Boolean> {
        try{
            const buildingPoints: PointDoc = await this.rxCollection.findOne().where({
                $and: [{"buildingId": buildingId}, {[stage]: { $gt: null}}, {[stage]: {$ne: ""}}, {[stage]: { $ne: "no"}}]
            }).exec()

            if (buildingPoints) {
                return true
            } else {
                return false
            }
        } catch(error) {
            console.warn(error)
        }
    }

    update(point: Point) {
      return this.restClient.http.patch(this.restClient.urlPath, point, {
        observe: "response",
      });
    }

    // this uses REST call to postgres db (rxdb uses _id and postgres uses id)
    // For now just convert id to _id so we can reuse Point model object
    async findPathlessByBuildingId(buildingId: string): Promise<Point[]> {
        try {
            const result: any = await firstValueFrom(
                this.restClient.http.get(`${this.restClient.urlPath}/findPathlessByBuildingId/${buildingId}`)
            );
            const resp : Point[] = result.data?.map(point=>({ ...point,_id: point.id}));
            //console.dir(resp)
            return resp;
        } catch (error) {
            console.error("findPathlessPointsByBuildingId() error: " + error?.message);
            throw error;
        }
    }

}